/*
 * @Author: your name
 * @Date: 2022-01-28 15:32:26
 * @LastEditTime: 2024-11-21 21:07:59
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\filterField\BsyFilterText\index.jsx
 */

import React from 'react'
import { BsyUtils } from '../../../utils/Utils';
import BsyNumber from '../../BsyNumber';
import BsyNumberLimit from '../../BsyNumberLimit';
import BsySelect from '../../BsySelect';

import BsyFilterBase from '../BsyFilterBase';

import './index.css'
import { BsyConfig } from '../../../global/BsyConfig';

export class BsyFilterNumber extends BsyFilterBase {

    DEFAULT_SIZE = {
        single: {
            minSizeX: 10,
            minSizeY: 6
        },
        double: {
            minSizeX: 10,
            minSizeY: 8
        }
    }

    constructor(props) {
        super({

            minRow: 8,
            onStopEdit: null,
            tick: [],
            tickValue:null,
            ...props
        })

        this.dashText = null;
    }


    _getAvailableMethods = () => {

        let i = this.options;
        if(i.tick.length) {
            return [BsyConfig().CONST.FILTER_METHOD.GT,
                BsyConfig().CONST.FILTER_METHOD.LT,
                BsyConfig().CONST.FILTER_METHOD.RG,
                BsyConfig().CONST.FILTER_METHOD.EP,
                BsyConfig().CONST.FILTER_METHOD.NEP]
        }
        

        return [BsyConfig().CONST.FILTER_METHOD.EQ,
        BsyConfig().CONST.FILTER_METHOD.NE,
        BsyConfig().CONST.FILTER_METHOD.GT,
        BsyConfig().CONST.FILTER_METHOD.GTE,
        BsyConfig().CONST.FILTER_METHOD.LT,
        BsyConfig().CONST.FILTER_METHOD.LTE,
        BsyConfig().CONST.FILTER_METHOD.RG,
        BsyConfig().CONST.FILTER_METHOD.EP,
        BsyConfig().CONST.FILTER_METHOD.NEP]
    }


    getValue = () => {

        if (this.dashText) {

            switch (this.method) {
                case BsyConfig().CONST.FILTER_METHOD.EQ:
                case BsyConfig().CONST.FILTER_METHOD.NE:
                case BsyConfig().CONST.FILTER_METHOD.GT:
                case BsyConfig().CONST.FILTER_METHOD.GTE:
                case BsyConfig().CONST.FILTER_METHOD.LT:
                case BsyConfig().CONST.FILTER_METHOD.LTE:
                    return {
                        value: this.dashText.getText()
                    };
                case BsyConfig().CONST.FILTER_METHOD.RG:
                    return this.dashText.getText();
                default:
                    return null
            }

        }
        return null
    }

    getContext = (e) => {
        this.dashText = e;
    }

    setValue = (t, method,tickValue) => {
        this.value = t || {};
        if (method)
          this.method = method || this.options.method;
        if (tickValue)
            this.tickValue = tickValue || this.options.tickValue;
        this.setState({})
    }
      
    renderCont = () => {
        let e = this
        let i = this.options;
        let val = this.getMiddleValue();
        e.tickValue = e.tickValue || i.tickValue

        switch (e.method) {
            case BsyConfig().CONST.FILTER_METHOD.EQ:
            case BsyConfig().CONST.FILTER_METHOD.NE:
            case BsyConfig().CONST.FILTER_METHOD.GT:
            case BsyConfig().CONST.FILTER_METHOD.GTE:
            case BsyConfig().CONST.FILTER_METHOD.LT:
            case BsyConfig().CONST.FILTER_METHOD.LTE:

                if(!BsyUtils.isObjectEmpty(i.tick)) {
                    if(val) {
                        if(e.tickValue && e.tickValue.min) {
                            e.tickValue = 'minute';
                        }  
       
                        if(val && val.value) {
                            switch(e.tickValue) {
                                case "hour":{
                                    val.value = val.value / (60 * 60);
                                    break;
                                }
                                case "days":{
                                    val.value = val.value / (60 * 60 * 24);
                                    break;
                                }
                                case "minute":
                                default:{
                                    val.value = val.value / 60;
                                    break;
                                }
                            }
                        }
                    }
                }

                return <>
                    <BsyNumber
                        value={val ? val.value : null}
                        width={'100%'}
                        theme={this.props.theme}
                        height={34}
                        onStopEdit={e1 => {
                            e.value = e.getValue()
                            BsyUtils.applyFunc(e, i.onStopEdit, [{
                                value: e.getValue(),
                                valueMode: e.valueMode,
                                method: e.method,
                                tickValue:e.tickValue
                            }, i], !1)
                        }}
                        getContext={this.getContext}
                    ></BsyNumber>
                    {
                        i.tick.length ? <BsySelect
                            allowBlank={false}
                            searchable={false}
                            width={50}
                            height={34}
                            value={e.tickValue}
                            items={[...i.tick]}
                            onStopEdit={(val) => {
                                e.tickValue = val;
                                BsyUtils.applyFunc(e, i.onStopEdit, [{
                                    value: e.getValue(),
                                    valueMode: e.valueMode,
                                    method: e.method,
                                    tickValue:e.tickValue
                                }, i], !1)
                            }}

                        ></BsySelect> : ''
                    }
                </>

            case BsyConfig().CONST.FILTER_METHOD.RG:

                    if(!BsyUtils.isObjectEmpty(i.tick)) {
                        if(val) {
                      
                            if(BsyUtils.isString(e.tickValue)) {
                                e.tickValue = {};
                            } else {
                                e.tickValue = e.tickValue || {}
                            }
                            if(val.min) {
                                switch(e.tickValue.min) {
                        
                                    case "hour":{
                                        val.min = val.min / (60 * 60);
                                        break;
                                    }
                                    case "days":{
                                        val.min = val.min / (60 * 60 * 24);
                                        break;
                                    }
                                    case "minute":
                                    default:{
                                        val.min = val.min / 60;
                                        break;
                                    }
                                }
                            }
                            if(val.max) {
                                switch(e.tickValue.max) {
                           
                                    case "hour":{
                                        val.max = val.max / (60 * 60);
                                        break;
                                    }
                                    case "days":{
                                        val.max = val.max / (60 * 60 * 24);
                                        break;
                                    }
                                    case "minute":
                                    default:{
                                        val.max = val.max / 60;
                                        break;
                                    }
                                }
                            }
                  
                        }
                    }
               

                return <BsyNumberLimit
                    value={val}
                    theme={this.props.theme}
                    width={'100%'}
                    tick={i.tick}
                    height={34}
                    tickValue={e.tickValue}
                    width4number={'auto'}
                    customCls={i.height > i.minRow ? "wrap" : ""}
                    onStopEdit={e1 => {
                        e.value = e.getValue()
                        e.tickValue = this.dashText.getTickValue ? this.dashText.getTickValue() : null;
                        BsyUtils.applyFunc(e, i.onStopEdit, [{
                            value: e.getValue(),
                            valueMode: e.valueMode,
                            method: e.method,
                            tickValue:e.tickValue
                        }, i], !1)
                    }}
                    getContext={this.getContext}
                ></BsyNumberLimit>

            default:
                return '';
        }


    }

    render() {
        return (<>
            {
                this.createTitleBar()
            }
            <div className='bsy-dash-cont' >
                {
                    this.renderCont()
                }
            </div>
        </>)
    }

}

